import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FilterPopoverUI } from '@/comps/FilterPicker/FilterPopoverUI';
import { FilterIcon } from 'lucide-react';
import { FilterButtonProps, GenericFilter } from '@/comps/FilterPicker/FilterPicker';
import { FilterContentV2 } from '@/comps/FilterPicker/FilterContentV2';
import { isFilterDefined } from '@/models/common/filters';
export const FilterButton = t0 => {
  const $ = _c(58);
  const {
    filters,
    setFilters,
    filters_v2,
    timeRange,
    projectId,
    volumeKind,
    availableFilterKinds,
    children,
    disabled,
    disabledMessage,
    title,
    filterListPrepend,
    showDraftActions,
    draftActions,
    hasDraftEdits,
    additionalFilters,
    showFilters: t1,
    showAdditionalFilterKinds: t2,
    onChecked,
    align,
    loading,
    overrideSelectedFilters,
    ignoreFilters,
    side,
    preOpen,
    keepOpen,
    id,
    icon,
    hideSavedFilters,
    triggerClassName,
    isGlobal,
    modal
  } = t0;
  const showFilters = t1 === undefined ? true : t1;
  const showAdditionalFilterKinds = t2 === undefined ? false : t2;
  const [filterKind, setFilterKind] = useState(null);
  const [open, setOpen] = useState(preOpen ?? false);
  const tourForceOpenRef = useRef(false);
  const [search, setSearch] = useState("");
  let t3;
  if ($[0] !== filters) {
    t3 = filters.filter(_temp);
    $[0] = filters;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const appliedFiltersLen = t3.length;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setFilterKind(null);
      setOpen(false);
      setSearch("");
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const reset = t4;
  let t5;
  let t6;
  if ($[3] !== isGlobal) {
    t5 = () => {
      if (!isGlobal) {
        return;
      }
      const handleOpen = () => {
        tourForceOpenRef.current = true;
        setOpen(true);
      };
      const handleClose = () => {
        if (!tourForceOpenRef.current) {
          return;
        }
        tourForceOpenRef.current = false;
        reset();
      };
      document.addEventListener("nebuly:tour-open-global-filter", handleOpen);
      document.addEventListener("nebuly:tour-close-global-filter", handleClose);
      return () => {
        document.removeEventListener("nebuly:tour-open-global-filter", handleOpen);
        document.removeEventListener("nebuly:tour-close-global-filter", handleClose);
      };
    };
    t6 = [isGlobal, reset];
    $[3] = isGlobal;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  useEffect(t5, t6);
  let t7;
  if ($[6] !== availableFilterKinds || $[7] !== disabled || $[8] !== keepOpen) {
    t7 = nextOpen => {
      if (disabled) {
        return;
      }
      if (tourForceOpenRef.current && !nextOpen) {
        return;
      }
      if (keepOpen && !nextOpen) {
        return;
      }
      setOpen(nextOpen);
      if (nextOpen && availableFilterKinds.length === 1) {
        setFilterKind(availableFilterKinds[0]);
      }
      if (!nextOpen) {
        reset();
      }
    };
    $[6] = availableFilterKinds;
    $[7] = disabled;
    $[8] = keepOpen;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleOpenChange = t7;
  const t8 = title || "Filter";
  const t9 = `${appliedFiltersLen} applied`;
  const t10 = showFilters && !!appliedFiltersLen;
  const t11 = icon ?? FilterIcon;
  let t12;
  if ($[10] !== setFilters) {
    t12 = () => {
      setFilters([]);
      reset();
    };
    $[10] = setFilters;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const t13 = hasDraftEdits ?? showDraftActions;
  let t14;
  if ($[12] !== additionalFilters || $[13] !== align || $[14] !== availableFilterKinds || $[15] !== disabled || $[16] !== draftActions || $[17] !== filterKind || $[18] !== filterListPrepend || $[19] !== filters || $[20] !== filters_v2 || $[21] !== handleOpenChange || $[22] !== hideSavedFilters || $[23] !== ignoreFilters || $[24] !== isGlobal || $[25] !== loading || $[26] !== onChecked || $[27] !== open || $[28] !== overrideSelectedFilters || $[29] !== projectId || $[30] !== search || $[31] !== setFilters || $[32] !== showAdditionalFilterKinds || $[33] !== showDraftActions || $[34] !== showFilters || $[35] !== timeRange || $[36] !== title || $[37] !== volumeKind) {
    t14 = <FilterContentV2 availableFilterKinds={availableFilterKinds} filters={filters} filters_v2={filters_v2} setFilters={setFilters} additionalFilters={additionalFilters} timeRange={timeRange} projectId={projectId} volumeKind={volumeKind} disabled={disabled} title={title} filterListPrepend={filterListPrepend} showDraftActions={showDraftActions} draftActions={draftActions} showFilters={showFilters} showAdditionalFilterKinds={showAdditionalFilterKinds} onChecked={onChecked} align={align} loading={loading} overrideSelectedFilters={overrideSelectedFilters} ignoreFilters={ignoreFilters} open={open} setOpen={handleOpenChange} filterKind={filterKind} setFilterKind={setFilterKind} search={search} setSearch={setSearch} isPopover={true} isGlobal={isGlobal} hideSavedFilters={hideSavedFilters} />;
    $[12] = additionalFilters;
    $[13] = align;
    $[14] = availableFilterKinds;
    $[15] = disabled;
    $[16] = draftActions;
    $[17] = filterKind;
    $[18] = filterListPrepend;
    $[19] = filters;
    $[20] = filters_v2;
    $[21] = handleOpenChange;
    $[22] = hideSavedFilters;
    $[23] = ignoreFilters;
    $[24] = isGlobal;
    $[25] = loading;
    $[26] = onChecked;
    $[27] = open;
    $[28] = overrideSelectedFilters;
    $[29] = projectId;
    $[30] = search;
    $[31] = setFilters;
    $[32] = showAdditionalFilterKinds;
    $[33] = showDraftActions;
    $[34] = showFilters;
    $[35] = timeRange;
    $[36] = title;
    $[37] = volumeKind;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== align || $[40] !== appliedFiltersLen || $[41] !== children || $[42] !== disabled || $[43] !== disabledMessage || $[44] !== handleOpenChange || $[45] !== id || $[46] !== modal || $[47] !== open || $[48] !== side || $[49] !== t10 || $[50] !== t11 || $[51] !== t12 || $[52] !== t13 || $[53] !== t14 || $[54] !== t8 || $[55] !== t9 || $[56] !== triggerClassName) {
    t15 = <FilterPopoverUI id={id} open={open} onOpenChange={handleOpenChange} title={t8} disabled={disabled} disabledMessage={disabledMessage} triggerContent={children} appliedFiltersText={t9} showAppliedFilters={t10} triggerClassName={triggerClassName} align={align} icon={t11} className="h-auto min-h-0 w-125 max-w-125 min-w-125 overflow-visible border-0 bg-transparent! shadow-none" side={side} nAppliedFilters={appliedFiltersLen} onFiltersClear={t12} hasDraftEdits={t13} modal={modal}>{t14}</FilterPopoverUI>;
    $[39] = align;
    $[40] = appliedFiltersLen;
    $[41] = children;
    $[42] = disabled;
    $[43] = disabledMessage;
    $[44] = handleOpenChange;
    $[45] = id;
    $[46] = modal;
    $[47] = open;
    $[48] = side;
    $[49] = t10;
    $[50] = t11;
    $[51] = t12;
    $[52] = t13;
    $[53] = t14;
    $[54] = t8;
    $[55] = t9;
    $[56] = triggerClassName;
    $[57] = t15;
  } else {
    t15 = $[57];
  }
  return t15;
};
function _temp(filter) {
  return isFilterDefined(filter);
}